import React from "react";
import redirectURL from "../../redirectURL";

// Hub performance bands (Excellent / Good / Poor) shared by the Live and Detailed dashboards.
// The numbers live in Mongo (dashboard_performance_config) and are edited from
// Masters > Hub Performance Config, so the bands can be changed without a release.

// Used until the API answers and whenever it fails - the dashboards must still render.
export const DEFAULT_PERFORMANCE_CONFIG = {
  excellent_min: 90,
  good_min: 80,
};

export function normalisePerformanceConfig(config) {
  var source = config || {};
  var excellent = Number(source.excellent_min);
  var good = Number(source.good_min);

  if (!isFinite(excellent)) excellent = DEFAULT_PERFORMANCE_CONFIG.excellent_min;
  if (!isFinite(good)) good = DEFAULT_PERFORMANCE_CONFIG.good_min;

  // A Good floor above the Excellent floor would leave Good unreachable
  if (good > excellent) good = excellent;

  return { excellent_min: excellent, good_min: good };
}

export function fetchPerformanceConfig() {
  return redirectURL
    .post("/msildashboard/getHubPerformanceConfig", {})
    .then(function (response) {
      var body = response && response.data ? response.data : {};
      if (body.status === "Success") return normalisePerformanceConfig(body.config);
      return DEFAULT_PERFORMANCE_CONFIG;
    })
    .catch(function () {
      // A config outage must never blank the dashboards
      return DEFAULT_PERFORMANCE_CONFIG;
    });
}

export function performanceLabel(pct, config) {
  var bands = normalisePerformanceConfig(config);
  var p = Number(pct);
  if (!isFinite(p)) p = 0;

  if (p >= bands.excellent_min) return "Excellent";
  if (p >= bands.good_min) return "Good";
  return "Poor";
}

export function performanceFillForLabel(label) {
  return label === "Excellent" ? "greenFill" : label === "Good" ? "yellowFill" : "redFill";
}

export function performanceFill(pct, config) {
  return performanceFillForLabel(performanceLabel(pct, config));
}

// Detailed dashboard uses its own dot classes for the comparison badges
export function performanceBadgeClass(pct, config) {
  var label = performanceLabel(pct, config);
  if (label === "Excellent") return "perfDot perfGreen";
  if (label === "Good") return "perfDot perfYellow";
  return "perfDot perfRed";
}

export function performanceLegendItems(config) {
  var bands = normalisePerformanceConfig(config);
  return [
    { dot: "greenFill", text: "Excellent (≥" + bands.excellent_min + "%)" },
    { dot: "yellowFill", text: "Good (" + bands.good_min + "% to <" + bands.excellent_min + "%)" },
    { dot: "redFill", text: "Poor (<" + bands.good_min + "%)" },
  ];
}

export function PerformanceLegend(props) {
  var items = performanceLegendItems(props.config);
  return (
    <div className="legendRow">
      <span className="legendTextBold">Performance Parameter:</span>
      {items.map(function (item) {
        return (
          <span className="legendItem" key={item.dot}>
            <span className={"dot " + item.dot} /> {item.text}
          </span>
        );
      })}
    </div>
  );
}
